import { usePlaybookQuery, useCreatePlaybookMutation, useUpdatePlaybookMutation, useDeletePlaybookMutation } from './usePlaybooksQuery';
import { Playbook } from '../types';

export const usePlaybook = (playbookId?: string) => {
    const { data: record, isLoading: loading, refetch: fetchRecord } = usePlaybookQuery(playbookId || '');
    const createPlaybookMutation = useCreatePlaybookMutation();
    const updatePlaybookMutation = useUpdatePlaybookMutation();
    const deletePlaybookMutation = useDeletePlaybookMutation();

    const createRecord = async (values: Playbook) => {
        return await createPlaybookMutation.mutateAsync(values);
    };

    const updateRecord = async (values: Playbook) => {
        if (typeof playbookId === 'undefined') {
            throw new Error('playbookId is required parameter');
        }
        return await updatePlaybookMutation.mutateAsync({ id: playbookId, record: values });
    };

    const deleteRecord = async () => {
        if (typeof playbookId === 'undefined') {
            throw new Error('playbookId is required parameter');
        }
        return await deletePlaybookMutation.mutateAsync(playbookId);
    };

    return {
        record,
        loading,
        fetchRecord,
        createRecord,
        updateRecord,
        deleteRecord,
    };
};
